// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";

const initialState = {
  principals: [],
  loading: false,
  value: 0,
};

export const getPrincipals = createAsyncThunk(
  "posts/getPrincipals",
  async thunkAPI => {
    const res = await http.get("/principals");
    return res.data.sort((a, b) => a.name.localeCompare(b.name));
  },
);

const principalsSlice = createSlice({
  name: "principals",
  initialState,
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  extraReducers: {
    [getPrincipals.pending]: state => {
      state.loading = true;
    },
    [getPrincipals.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.principals = payload;
    },
    [getPrincipals.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  updateUnitOnList,
} = principalsSlice.actions;

export const principalsReducer = principalsSlice.reducer;
